import { Button } from '@/components'
import { ChangeEvent, useRef, useState } from 'react'

function FileButton ( props ) {
    const {
        style, singleMaxFileSize, multiMaxFileSize,
        noClearAfterUpload = false,
        onClick,
        children,
        ...rest
    } = props
    const [ value, setValue ] = useState( '' )
    const inputRef = useRef( null )

    const onCustomClick = () => {
        inputRef?.current?.click()
    }

    const getAttachFiles = ( files?: FileList ): FileList | Record<string,any>[] => {
        let valueCheck = true
        let totalFileSize = 0
        const fileList: FileList | Record<string,any>[] = []

        for ( const file of files ) {
            const { size } = file
            if ( !validateMaxFileSize( singleMaxFileSize, size ) ) {
                valueCheck = false
            }
            fileList.push( file )
            totalFileSize += size
        }

        if ( !validateMaxFileSize( multiMaxFileSize, totalFileSize ) ) {
            valueCheck = false
        }

        return valueCheck ? fileList : []
    }

    const onChange = ( e: ChangeEvent<HTMLInputElement> ): void => {
        const targetFiles = getAttachFiles( e.target?.files ) as FileList

        setValue( noClearAfterUpload ? e?.target?.value : '' )

        onClick && onClick( targetFiles )
    }

    const getMaxFileSize = ( fileSize: string ): number => {
        const size = Number( fileSize.replace( /^[0-9]/g, '' ) )
        const fileSizeUnit = fileSize.replace( /[0-9]/g, '' )

        return fileSizeUnit === 'K' ? 1024 * size : 1024 * 1024 * size
    }

    const validateFormatFileSize = ( fileSize: string ): boolean => {
        return /.+['M'|'K']$/.test( fileSize )
    }

    const validateMaxFileSize = ( maxFileSize: string, fileSize: number ): boolean => {
        if ( !maxFileSize ) return true
        if ( validateFormatFileSize( maxFileSize ) ) return false
        if ( getMaxFileSize( maxFileSize ) < fileSize ) return false

        return true
    }

    return (
        <>
            <Button
                { ...rest }
                onClick={ onCustomClick }
            >
                { children }
            </Button>
            <input
                { ...rest }
                type="file"
                multiple
                ref={ inputRef }
                value={ value }
                style={ { display: 'none' } }
                onChange={ onChange }
            />
        </>
    )
}

export default FileButton